import { VIEW_AS_MODE_KEY } from '@core/auth/services/data-storage.service';
import { UrlParams } from '@core/constants/URL_PARAMS';
import { CompanyCustomizationsService } from '@core/services/customization/customizations.service';
import { AppHostService } from '@core/services/host.service';
import { environment } from '@env';
import { Observable } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';

export function initializeApp(host: AppHostService, customizations: CompanyCustomizationsService): () => Observable<void> {
  UrlParams.init();
  return () =>
    host.initHostAndResolveCompanyUuid().pipe(
      tap((companyUuid: string) => initializeTBLogs(companyUuid)),
      switchMap((companyUuid: string) => customizations.loadCustomizations(companyUuid))
    );
}

function initializeTBLogs(companyUuid: string): void {
  if (!environment.acTrackerUrl) {
    return;
  }
  // a view-as tab must not load the tracker SDK at all — guarding only setUser still lets
  // the SDK record the admin's page views against the advocate's session
  if (sessionStorage.getItem(VIEW_AS_MODE_KEY) === 'true') {
    return;
  }
  const acWindow = window as any;
  acWindow.TB_LOGS = acWindow.TB_LOGS || {
    q: [],
    onReady: function (callback: any): void {
      acWindow.TB_LOGS.q.push(callback);
    }
  };

  const scriptElement = document.createElement('script');
  scriptElement.async = true;
  scriptElement.src = environment.acTrackerUrl;

  const firstScript: any = document.getElementsByTagName('script')[0];
  firstScript.parentNode.insertBefore(scriptElement, firstScript);

  // init tracker SDK
  acWindow.TB_LOGS.onReady(function () {
    acWindow.TB_LOGS.init({
      clientToken: companyUuid
    });
  });
}
